// Footer.jsx
import React from 'react';

function Footer() {
  return (
    <footer className="main-footer background-black">
      <div className="main-footer__bg background-black" style={{ backgroundImage: "url(/assets/images/slider/footer.webp?v=20260924)" }}></div>
      <div className="main-footer__top">
        <div className="container">
          <a href="/" className="main-footer__logo">
            <img src="/assets/images/logo/logo.png?v=20260924" width="125" alt="Hanthana House" />
          </a>
          <div className="main-footer__social">
            <a href="https://facebook.com/hanthanahouse"><i className="fab fa-facebook"></i></a>
            <a href="https://instagram.com/hanthanahousekandy"><i className="fab fa-instagram"></i></a>
          </div>
        </div>
      </div>
      <div className="main-footer__bottom">
        <div className="container">
          <div className="main-footer__bottom__inner row">
            <div className="col-lg-7">
              <p style={{ color: 'white' }}>
                Nestled in the serene hills of Kandy, this charming villa offers breathtaking views of lush greenery and rolling landscapes. A perfect blend of modern comfort and nature's tranquility, it promises an idyllic escape, just minutes from the city's cultural landmarks.
              </p>
              <p style={{ color: 'white' }}>
                © {new Date().getFullYear()} Hanthana House Kandy. All Rights Reserved. Designed by <a href="https://ollcode.com"><b>Ollcode</b></a>
              </p>
            </div>
            <div className="col-lg-2">
              <ul className="list-unstyled footer-widget__links">
                <li><a href="/" style={{ color: 'white' }}>Home</a></li>
                <li><a href="/rooms" style={{ color: 'white' }}>Rooms</a></li>
                <li><a href="/experiences" style={{ color: 'white' }}>Experiences</a></li>
                <li><a href="/gallery" style={{ color: 'white' }}>Gallery</a></li>
                <li><a href="/about" style={{ color: 'white' }}>About Us</a></li>
                <li><a href="/contact" style={{ color: 'white' }}>Contact Us</a></li>
              </ul>
            </div>
            <div className="col-lg-3">
              <ul className="list-unstyled footer-widget__contact">
                <li style={{ color: 'white' }}><strong>Email:</strong><br />hanthanahouse@gmail.com</li>
                <li style={{ color: 'white' }}><strong>Phone:</strong><br />+94 (81) 221 8625, +94 (77) 737 4560</li>
                <li style={{ color: 'white' }}><strong>Address:</strong><br />No. 108, Richmond Hill Residencies, Thapodarama Road, Hanthana, Kandy</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
